import Vue from 'vue'
import Vuex from 'vuex'

import loading from './modules/loading.js'
import tip from './modules/tip.js'
import confirm from './modules/confirm.js'
import toast from './modules/toast.js'
import community from './modules/community.js'
import certificate from './modules/certificate'
import login from './modules/login.js'
import brand from './modules/brand'
import work from './modules/work'
import message from './modules/message'
import rank from './modules/rank'
import company from './modules/company'
import user from './modules/user'
import myfollower from './modules/myfollower'
import video_course from './modules/video_course'
import activity from './modules/activity'
import school from './modules/school'
import address from './modules/address'

Vue.use(Vuex)
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    count: 0
  },
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    loading,
    tip,
    confirm,
    toast,
    community,
    certificate,
    login,
    brand,
    work,
    message,
    rank,
    company,
    user,
    myfollower,
    video_course,
    activity,
    school,
    address
  }
})
export default store
